// extracted by mini-css-extract-plugin
export var barContainer = "_5u-0";
export var extraThin = "_5u-3";
export var fillBar = "_5u-6";
export var fillContainer = "_5u-4";
export var overflow = "_5u-8";
export var overflowContainer = "_5u-5";
export var regular = "_5u-7";
export var thick = "_5u-1";
export var thin = "_5u-2";